import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './vendor/font-awesome/css/font-awesome.min.css'
import './fonts/Stroke-Gap-Icons-Webfont/style.css'
import './vendor/bootstrap/dist/css/bootstrap.min.css'
import './vendor/owl-carousel/owl-carousel/owl.carousel.css'
import './vendor/slider-pro/dist/css/slider-pro.min.css'
import './vendor/slick-carousel/slick/slick.css'
import './vendor/animate.css/animate.min.css'
import './vendor/fancybox/source/jquery.fancybox.css'
import './css/main.css';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import Policy from './pages/Policy';
import TermsConditions from './pages/TermsConditions';
import RefundPolicy from './pages/RefundPolicy';
import { HelmetProvider } from 'react-helmet-async';
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

const root = ReactDOM.createRoot(document.getElementById('root'));

// Public pages served at clean URLs (no "#/") so they can be shared directly.
const standalonePages = {
  '/policy': Policy,
  '/terms-and-conditions': TermsConditions,
  '/refund-policy': RefundPolicy,
};
const StandalonePage = standalonePages[window.location.pathname.replace(/\/$/, '')];

if (StandalonePage) {
  root.render(
    <HelmetProvider>
      <BrowserRouter>
        <StandalonePage />
      </BrowserRouter>
    </HelmetProvider>
  );
} else {
  root.render(
    <HelmetProvider>
    <HashRouter>
      <App />
    </HashRouter>
  </HelmetProvider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
